<template>
	<input
		v-model="model"
		v-maska="options"
		data-maska="(###) ###-####"
		placeholder="(___) ___-____"
		class="input"
		type="tel"
		maxlength="14"
	/>
</template>
<script setup lang="ts">
import { MaskaDetail } from 'maska';
import { ref } from 'vue';

const unmasked = ref('');

const model = defineModel({
	set: (value: string) => {
		if (unmasked.value) {
			return unmasked.value;
		}
		return value;
	}
});

const options = {
	onMaska: (detail: MaskaDetail) => {
		unmasked.value = detail.unmasked;
	}
};
</script>
